import React from 'react';
import graphql from 'graphql';
import styled from 'styled-components';
import { PageWrapper, mediaQueries, Measures, Heading, Paragraph, spacing } from '../components/Styling';
import HTMLtoJSX from '../components/HTMLtoJSX';

const StyledPage = styled(PageWrapper)`
  flex: 1;
  p {
    margin-top: 0;
  }
`;

export default ({ data, transition }) => {
  const { markdownRemark: page } = data;
  return (
    <StyledPage maxWidth={Measures[2]} style={transition && transition.style}>
      <Heading>{page.frontmatter.title}</Heading>
      <HTMLtoJSX content={page.html} />
    </StyledPage>
  );
};

export const partnersQuery = graphql`
  query PartnersPage($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        image
        path
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/partners.js